import { makeStyles } from 'tss-react/mui';
import { Select, SelectProps, SelectRaw } from './Select';

const useSelectStyles = makeStyles({ name: 'AppointmentRepetition' })({
  root: {
    '&:focus': {
      background: 'transparent',
    },
    '.MuiOutlinedInput-input.MuiSelect-select': {
      paddingTop: 0,
      paddingBottom: 0,
    }
  },
  select: {
    padding: 0,
  },
});

const useStyles = makeStyles()({
  root: {
    '& fieldset': {
      display: 'none',
    }
  }
});

export type MobileDropdownProps = SelectProps & {
  raw?: boolean;
};

export const MobileDropdown: React.FC<MobileDropdownProps> = props => {
  const { classes } = useStyles();
  const { classes: selectClasses } = useSelectStyles();

  const SelectComponent = props.raw
    ? SelectRaw
    : Select;

  return (
    <SelectComponent
      {...props}
      fullWidth={false}
      className={classes.root}
      selectClasses={selectClasses}
      items={props.items}
    />
  );
};
